module.exports = __webpack_public_path__ + "1f5003cd3eaacc46d63daf78ffe36549.pdf";